module.exports = __webpack_public_path__ + "assets/img/track-bottom-text-light.c44887c3.svg";